import { Component, Input, OnInit, Inject } from '@angular/core';
import { InventoryDataService, WebService, lastValueFrom, PromptService } from '@services';
import { RmsPulldownRef } from '../../../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown-ref';
import { RMS_PULLDOWN_DATA } from '../../../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown.tokens';
import { FormsModule } from '@angular/forms'
import { RmsModule } from '@rms';

@Component({
  selector: 'app-group-management',
  imports: [RmsModule, FormsModule],
  templateUrl: './group-management.component.html',
  styleUrl: './group-management.component.scss'
})
export class GroupManagementComponent implements OnInit {
  Group: any = {};
  AvailableGroups: any[] = [];
  ParentGroups: any[] = [];
  Countries: any[] = [];
  GroupList: any[] = [];

  constructor(private inventoryDataService: InventoryDataService, private webService: WebService, @Inject(RMS_PULLDOWN_DATA) private data: any, public ref: RmsPulldownRef, private prompt: PromptService) {
    this.Group = data || {};
  }

  async ngOnInit() {
    await this.LoadData();
  }

  async LoadData() {
    const groups = await this.inventoryDataService.getData({
      keys: ['Groups', 'Countries']
    });
    this.AvailableGroups = groups['Groups'].sort((a: any, b: any) =>
      (a.GroupName ?? '').localeCompare(b.GroupName ?? '', undefined, {
        sensitivity: 'base' // ✅ ignores case + accents
      })
    );
    this.ParentGroups = groups['Groups'].filter((g: any) => g.IsParent)
      .sort((a: any, b: any) =>
        (a.GroupName ?? '').localeCompare(b.GroupName ?? '', undefined, {
          sensitivity: 'base' // ✅ ignores case + accents
        })
      );

    this.Countries = groups['Countries'].sort((a: any, b: any) =>
      (a.CountryName ?? '').localeCompare(b.CountryName ?? '', undefined, {
        sensitivity: 'base' // ✅ ignores case + accents
      })
    );
  }
  onSelectCountry() {
    const countryID = this.Group.CountryID;
    console.log(this.Group.CountryID);
    this.GroupList = this.AvailableGroups.filter((g: any) => g.CountryID === countryID).sort((a: any, b: any) =>
      a.IsParent === b.IsParent ? 0 : a.IsParent ? -1 : 1
    );
    this.ParentGroups = this.GroupList.filter((g: any) => g.IsParent)
  }
  save() {

    const groupExists = this.AvailableGroups.find((g: any) =>
      (g.GroupName ?? '').toLowerCase() === (this.Group.GroupName ?? '').toLowerCase() &&
      g.GroupID !== this.Group.GroupID
    );
    if (groupExists) {
      this.prompt.open({
        promptText: `A group with the name "${this.Group.GroupName}" already exists for the selected country. Please choose a different name.`,
        buttons: [{ label: 'OK', action: () => this.prompt.close(), buttonClass: 'btn-bg-red' }]
      })
      return;
    }
    this.ref.close({...this.Group, cancelled: false });
  }
  cancel() {
    this.ref.close({cancelled: true })
  }
}
